import React, { Component } from 'react';

import './style.css';


export default class Button extends Component {

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit();
  }
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <button className={'button ' + classes}
              onMouseEnter={this.props.onMouseEnter}
              onMouseLeave={this.props.onMouseLeave}
              onClick={this.props.onClick}
              onSubmit={this.onSubmit.bind(this)}
      >
        {this.props.children}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/button/Button.js